import React, { createContext, useContext, useState } from 'react';
const TeamsContext = createContext();

export const TeamsProvider = ({ children }) => {
  const [isTeamsInitialized, setIsTeamsInitialized] = useState(false); // Renamed for clarity

  return (
    <TeamsContext.Provider
      value={{ isTeamsInitialized, setIsTeamsInitialized }}
    >
      {children}
    </TeamsContext.Provider>
  );
};

// Custom hook for easy consumption.
export const useTeams = () => useContext(TeamsContext);
